module.exports = __webpack_public_path__ + "img/auto.e7a3b1fa.png";